import React, { useState } from "react"
import {
  Box,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useQuery } from "react-query"
import useStickyState from "../hooks/useStickyState"
import { listGyms, normalizeSlug } from "../utils/gymApi"

export default function Gyms() {
  const navigate = useNavigate()
  const [recentGyms] = useStickyState([], "recentGyms")
  const [newSlug, setNewSlug] = useState("")
  const { data } = useQuery("gyms", listGyms)

  const goToGym = () => {
    const slug = normalizeSlug(newSlug)
    if (slug) {
      navigate(`/gym/${slug}`)
    }
  }

  const gyms = data?.gyms || []
  const recents = (recentGyms || []).filter((recent) =>
    gyms.length ? gyms.some((gym) => gym.slug === recent.slug) : true
  )

  return (
    <Box sx={{ maxWidth: 560, mx: "auto" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Gyms
      </Typography>
      <Typography color="text.secondary" align="center" gutterBottom>
        Every gym page remembers what's currently displayed on its kilter
        board.
      </Typography>
      {recents.length > 0 && (
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">Recent</Typography>
            <List dense>
              {recents.map((gym) => (
                <ListItem key={gym.slug} disablePadding>
                  <ListItemButton onClick={() => navigate(`/gym/${gym.slug}`)}>
                    <ListItemText primary={gym.name} secondary={gym.slug} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </CardContent>
        </Card>
      )}
      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6">All gyms</Typography>
          {gyms.length === 0 && (
            <Typography color="text.secondary">No gyms yet.</Typography>
          )}
          <List dense>
            {gyms.map((gym) => (
              <ListItem key={gym.slug} disablePadding>
                <ListItemButton onClick={() => navigate(`/gym/${gym.slug}`)}>
                  <ListItemText primary={gym.name} secondary={gym.slug} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h6" gutterBottom>
            New gym
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextField
              fullWidth
              size="small"
              label="Gym URL name, e.g. hangar-edinburgh"
              value={newSlug}
              onChange={(event) => setNewSlug(event.target.value)}
              onKeyDown={(event) => event.key === "Enter" && goToGym()}
            />
            <Button variant="contained" onClick={goToGym}>
              Go
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}
